import React, { Component } from 'react';
import '../styles/CreateUserForm.css';
import DropdownWidget from '../widgets/DropdownWidget';
import APIUserAccountRequest from '../api/APIUserAccountRequest';
import xButton from '../images/x.png';

class UserDetails extends Component
{
	constructor(props) {
		super(props);
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			region: "REGION",
			province: "PROVINCE",
			role: "-- SELECT --"
		};
		this.getUserById = this.getUserById.bind(this);
	}

	componentWillMount() {
		this.getUserById(this.props.userId);
	}

	componentDidMount() {
		const fields = document.querySelectorAll('.create-user *:not(button)');
		for(const f of fields) {
			f.disabled = true;
		}
	}

	getUserById(id) {
		const region = APIUserAccountRequest.getUserById(this.state.accessToken, id);
		region.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			this.setState({
				firstName: response.results.employeeBasicInfo.first_name,
				middleName: response.results.employeeBasicInfo.middle_name,
				lastName: response.results.employeeBasicInfo.last_name,
				extName: response.results.employeeBasicInfo.extension_name,
				region: response.results.userDetails.region,
				province: response.results.userDetails.province,
				role: response.results.userDetails.role,
				contactNo: response.results.employeeBasicInfo.contact_no,
				username: response.results.userDetails.username,
				data: response.results
			});
		});
	}

	render() {
		const view = <div className="create-user">
			<div className="cu-header">
				<div>USER DETAILS</div>
				<img src={xButton} className="close-icon" alt="ADD" onClick={() => {
					this.props.onSignal();
				}} />
			</div>
			<div className="cu-body">
				<div className="cu-fullname">
					<div>Full Name</div>
					<input type="text" id="cu-firstname" value={this.state.firstName} />
					<input type="text" id="cu-middlename" value={this.state.middleName} />
					<div>
						<input type="text" id="cu-lastname" value={this.state.lastName} />
						<input type="text" id="cu-extnname" value={this.state.extName} />
					</div>
				</div>
				<div className="cu-address">
					<div>Office Address</div>
					<input type="text" value={this.state.region} />
					<input type="text" value={this.state.province} />
				</div>
				<div className="cu-role">
					<div>Role</div>
					<input type="text" value={this.state.role} />
				</div>
				<div className="cu-contact">
					<div>Contact No.</div>
					<input type="text" value={this.state.contactNo} />
				</div>
				<div className="cu-login">
					<div>Login Credentials</div>
					<input type="text" id="cu-username" value={this.state.username} style={{'text-transform': 'none'}} />
					<input type="password" id="cu-password"  value="****************" />
				</div>
				<button className="green-two" onClick={() => {
					this.props.onSignal("update", this.state.data);
				}}>UPDATE</button>
			</div>
		</div>;
		return(view);
	}
}

export default UserDetails;
